import {
  formatPecentageValueWithOneDecimal,
  createKpiTileItem,
} from '../../../../utils/helper';
import { KpiHandler, IPCSummaryData } from './types';
import { KpiData } from 'components/redesign/KpiTile/types';

const wasteReduction: KpiHandler = {
  type: 'KpiTile',
  handler: (data: IPCSummaryData): KpiData => {
    const { wasteReductionPercentage, wasteReductionPercentageVsTarget } = data;

    const formattedValue = formatPecentageValueWithOneDecimal(
      wasteReductionPercentage
    );

    if (wasteReductionPercentageVsTarget !== null) {
      const tag = {
        text: `${wasteReductionPercentageVsTarget}`,
        isPositiveValue:
          wasteReductionPercentageVsTarget.toLowerCase() === 'positive',
        showArrow: false,
      };

      return createKpiTileItem('Waste Reduction in %', formattedValue, tag);
    }

    return createKpiTileItem('Waste Reduction in %', formattedValue);
  },
};

export default wasteReduction;
